// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","383":"0ce9979f","455":"b0748933","578":"9133ab67","977":"23814c44"}[chunkId] + ".chunk.js";
};